export const ROOBET_URL = 'https://go.roobet.com/visit/?bta=39358&brand=roobet';
export const WHALE_URL =
  'http://whalegames.gg/?start=293b61ee9426024f&utm_source=gocore&utm_medium=paid&utm_campaign=acq-seo-gr';
export const THUNDERPICK_URL =
  'https://go.thunder.partners/visit/?bta=37268&brand=thunderpick&campaign=GOCORE';
